import gql from 'graphql-tag';

const SWEEP_ACCOUNT_FIELDS = gql`
  fragment SweepAccountFields on SweepAccount {
    affinityStem
    stripeCustomerId
    contact {
      name
      email
      phone
      address {
        line1
        line2
        city
        state
        zip
      }
    }
    paymentMethods {
      id
      type
      last4
      brand
      bankName
      expMonth
      expYear
      isDefault
    }
    defaultPaymentMethodId
  }
`;

export const GET_SWEEP_ACCOUNT = gql`
  query getSweepAccount {
    getSweepAccount {
      ...SweepAccountFields
    }
  }
  ${SWEEP_ACCOUNT_FIELDS}
`;

// Internal staff charging a policy's agency sweep account for an agent (#36683).
export const GET_POLICY_SWEEP_ACCOUNT = gql`
  query getPolicySweepAccount($policyId: ID!) {
    getSweepAccount(policyId: $policyId) {
      ...SweepAccountFields
    }
  }
  ${SWEEP_ACCOUNT_FIELDS}
`;

// Agency-details pre-fill for the setup form (#33822): what we already hold for the
// caller's agency. All fields optional — absent ones stay blank + editable.
export const GET_SWEEP_ACCOUNT_PREFILL = gql`
  query getSweepAccountPrefill {
    getSweepAccountPrefill {
      name
      email
      phone
      line1
      city
      state
      zip
    }
  }
`;

export const CREATE_SWEEP_ACCOUNT = gql`
  mutation createSweepAccount(
    $contact: SweepAccountContactInput!
    $paymentMethodToken: String!
    $paymentMethodType: String!
  ) {
    createSweepAccount(contact: $contact, paymentMethodToken: $paymentMethodToken, paymentMethodType: $paymentMethodType) {
      ...SweepAccountFields
    }
  }
  ${SWEEP_ACCOUNT_FIELDS}
`;

export const ADD_SWEEP_PAYMENT_METHOD = gql`
  mutation addSweepPaymentMethod($paymentMethodToken: String!, $paymentMethodType: String!, $makeDefault: Boolean) {
    addSweepPaymentMethod(
      paymentMethodToken: $paymentMethodToken
      paymentMethodType: $paymentMethodType
      makeDefault: $makeDefault
    ) {
      ...SweepAccountFields
    }
  }
  ${SWEEP_ACCOUNT_FIELDS}
`;

export const REMOVE_SWEEP_PAYMENT_METHOD = gql`
  mutation removeSweepPaymentMethod($paymentMethodId: String!) {
    removeSweepPaymentMethod(paymentMethodId: $paymentMethodId) {
      ...SweepAccountFields
    }
  }
  ${SWEEP_ACCOUNT_FIELDS}
`;

export const SET_DEFAULT_SWEEP_PAYMENT_METHOD = gql`
  mutation setDefaultSweepPaymentMethod($paymentMethodId: String!) {
    setDefaultSweepPaymentMethod(paymentMethodId: $paymentMethodId) {
      ...SweepAccountFields
    }
  }
  ${SWEEP_ACCOUNT_FIELDS}
`;
